import networkTS from '@/misc/apis/networkTS'

export default {
  async enable(accountId: string, enable: boolean, clientId: string, clientSecret: string, loginUrl: string) {
    return networkTS.gocautionServiceEnable(accountId, {
      enable: enable,
      clientId: clientId,
      clientSecret: clientSecret,
      loginUrl: loginUrl
    })
      .then((response) => {
        return response.data
      })
  },
  async getAccountSettings(accountId: string) {
    return networkTS.gocautionServiceGetAccountSettings(accountId)
      .then(response => {
        return response.data
      })
  },
  async hasEnabled(accountId: string) {
    return networkTS.gocautionServiceHasEnabled(accountId)
      .then((response) => {
        return response.data
      })
  },
  async openDeposit(objectId: string, tenancyId: string, contactPersonId: string = '') {
    return networkTS.gocautionServiceOpenDeposit({
      objectId: objectId,
      tenancyId: tenancyId,
      contactPersonId: contactPersonId
    })
      .then((response) => {
        return response.data
      })
  },
  async getDepositInfo(tenancyId: string) {
    return networkTS.gocautionServiceGetDepositInfo(tenancyId)
      .then((response) => {
        return response.data
      })
  }
}
